
const baseUrl = process.env.NODE_ENV == 'development' ? 'http://127.0.0.1:3050': 'https://api.sonevawelcome.com';
const imageUrl = process.env.NODE_ENV == 'development' ? 'http://localhost:3050/images/': 'https://api.sonevawelcome.com/images/';
const avail = ['fushi','jani','secret','kiri']
export {
	baseUrl,
	imageUrl,
	avail
}
